import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, isValidElement, useCallback, useMemo, useState } from "react";
export const Funnel = (param)=>{
    let { step , children  } = param;
    const validElement = Children.toArray(children).filter(isValidElement);
    const targetElement = validElement.find((child)=>{
        var _child_props;
        return ((_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.name) === step;
    });
    if (!targetElement) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: targetElement
    });
};
export const Step = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export const useFunnel = (steps, defaultStep)=>{
    const [step, setStep] = useState(defaultStep);
    const FunnelElement = useMemo(()=>Object.assign((props)=>{
            return /*#__PURE__*/ _jsx(Funnel, {
                step: step,
                ...props
            });
        }, {
            Step: (props)=>/*#__PURE__*/ _jsx(Step, {
                    ...props
                })
        }), [
        step
    ]);
    const setStepMemoized = useCallback((newStep)=>{
        setStep(newStep);
    }, []);
    return [
        FunnelElement,
        setStepMemoized,
        step
    ];
};
